module.exports = __webpack_public_path__ + "static/media/amcIconFaq.df0f67aa.svg";